module.exports = "/assets/pattern-korw.jpg?RHp8vpP";